import { Icon } from '@iconify/react';
import React, { useState } from 'react';
import { ICreateInvoiceData } from '../../../../@types';
import { InfoCircle } from '../../../../assets/icons/InfoCircle';
import PlusBoxIcon from '../../../../assets/icons/PlusBoxIcon';
import { REOCCURRING_FREQUENCY } from '../../../../constants';
import { InvoiceValidationErrors } from '../../../../modules/invoice/invoice';
import { InvoiceErrors } from '../../../../modules/validateInvoiceForm';
import { formatMoney } from '../../../../utils';
import { ImportantCard } from '../../../common/TooltipCards/ImportantCard';
import { MiniCard } from '../../../common/TooltipCards/miniCards';
import { CheckboxComponent, DropdownComponent, InputComponent } from '../../../core/Forms';

interface InvoiceSummaryProps {
  subTotal: number;
  formData: ICreateInvoiceData;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  calcDiscount: number;
  calcTax: number;
  total: number;
  handleDropDownChange: (name: string, value: string) => void;
  handleIsReoccurringChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  validationResults: InvoiceErrors;
  invoiceNo?: string;
  sendEmail: boolean;
  markAsPaid: boolean;
  handleSendEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleMarkAsPaidChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  shouldSendWhatsApp: boolean;
  handleshouldSendWhatsAppChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InvoiceSummary: React.FC<InvoiceSummaryProps> = ({
  subTotal,
  formData,
  handleInputChange,
  calcDiscount,
  calcTax,
  total,
  handleDropDownChange,
  handleIsReoccurringChange,
  validationResults,
  sendEmail,
  markAsPaid,
  handleSendEmailChange,
  handleMarkAsPaidChange,
  handleshouldSendWhatsAppChange,
  shouldSendWhatsApp,

}) => {
  const [isMiniCardCustomerVisible, setIsMiniCardCustomerVisible] = useState(false);
  const [isReoccurringChecked, setIsReoccurringChecked] = React.useState(formData?.isReoccurring || false);
  const [draftValidationResults, setDraftValidationResults] = React.useState<InvoiceValidationErrors>({
    customerId: undefined,
    invoiceNumber: undefined,
    invoiceDueAt: '',
    description: undefined,
    status: undefined,
    issueDate: undefined,
    additionalInformation: undefined,
    shippingCharge: undefined,
    discount: undefined,
    tax: undefined,
    isReoccurring: undefined,
    isReoccurringStartDate: undefined,
    isReoccurringEndDate: undefined,
    reoccurringGroupName: undefined,
    task: undefined,
    inventories: undefined,
    currency: undefined,
    exchangeRate: undefined,
  });

  const handleInfoCircleHover = () => {
    setIsMiniCardCustomerVisible(true);
  };

  const handleInfoCircleMouseLeave = () => {
    setIsMiniCardCustomerVisible(false);
  };

  return (
    <div className="3xl:ml-[5em]">
      <h2 className="xl:text-[24px] mt-[1em] text-center">Fill In Additional Info, If Necessary</h2>
      <div className=" md:flex md:mt-[14px] 540:ml-[4em] md:gap-[12px] lg:flex lg:mt-[14px] lg:gap-[32px] md:ml-[-1.5em]">
        <div className="font-medium bg-white w-[350px]  360:w-[320px]  375:w-[340px] 414:w-[370px]  412:w-[370px] text-center ml-[-2em] px-10 py-2 mt-[1.5em] md:ml-[23em] lg:w-[350px] lg:ml-[24em] bigmd:ml-[27em] bigmd:w-[420px] biglg:w-[450px] biglg:ml-[33em] xl:w-[504px] 2xl:w-[580px] 3xl:w-[730px] 4xl:w-[890px]  2xl:ml-[40.5em] xl:ml-[39em]">
          <div className="flex justify-between text-[14px] ml-[-2em] mt-[1em]">
            <p className="pl-3">Sub Total</p>
            <p>{formatMoney(subTotal.toFixed(2), formData.currency)}</p>
          </div>
          <div className="flex justify-between my-4 text-[12px] ml-[-2em]">
            <p className="pl-3"> Discount</p>
            <div className="flex items-center mt-[2em] ml-[-18em]">
              <InputComponent
                type="number"
                value={formData?.discount}
                name="discount"
                handleChange={handleInputChange}
                className="w-[86px]  h-[40px]  ml- 540:ml-[-1.9em] rounded-lg xl:ml-[-6em] lg:ml-[-0.5em] xl:w-[150px] 2xl:ml-[-10.5em] biglg:ml-[-6.5em] md:ml-[-1.8em] bigmd:ml-[-2.8em] 412:ml-[-1.9em] 360:ml-[0.9em] 414:ml-[-2.2em] 375:ml-[-0.5em]"
              />
              <div className="inline-flex h-[45px] mt-[0.5em] items-center justify-end pl-[12px] pr-0 py-0 relative bg-[#e8e8e8] rounded-[0px_4px_4px_0px]">
                <div className="relative w-fit [font-family:'Fellix-SemiBold',Helvetica] font-semibold text-black text-[14px] tracking-[0] leading-[18px] whitespace-nowrap">
                  %
                </div>
                <Icon icon="mdi:chevron-down" color="black" width="20" height="20" />
              </div>
            </div>
            <p className="mt-[3em] ml-[-3em]">{formatMoney(calcDiscount.toFixed(2), formData.currency)}</p>
          </div>

          {/* VAT */}
          <div className="flex justify-between my-5 text-[12px] ml-[-2em]">
            <p className="pl-3">VAT</p>
            <div className="flex items-center mt-[2em] ml-[-18em]">
              <InputComponent
                type="number"
                value={formData?.tax}
                name="tax"
                placeholder="Enter Tax%"
                handleChange={handleInputChange}
                className="w-[147px] h-[40px]   412:ml-[-29em] 360:ml-[-22.5em] 414:ml-[-29em]  375:ml-[-25.5em] rounded-lg inner-shadow xl:ml-[-42em] xl:w-[200px] 2xl:ml-[-51em] biglg:ml-[-38.5em] lg:ml-[-26em] bigmd:ml-[-35em] "
              />
            </div>
          </div>
          <p className="mt-[-2.7em] ml-[2em] text-[12px] xl:ml-[33em] 2xl:ml-[39em] lg:ml-[21em] biglg:ml-[29em] md:ml-[22em] bigmd:ml-[25em] 375:ml-[19em] 414:ml-[22em] 360:ml-[17.5em] 412:ml-[22em]">
            {formatMoney(calcTax.toFixed(2), formData.currency)}
          </p>
          <hr className="w-full mt-[1em]" />
          <div className="flex justify-between my-5 ml-[-1.5em]">
            <p className="pl-3">Total</p>
            <p>{formatMoney(total.toFixed(2), formData.currency)}</p>
          </div>
        </div>
        <div className=" mt-[20px] w-[350px] 412:w-[370px] 360:w-[320px] 375:w-[340px]  414:w-[370px] h-[9vh] ml-[-2em] md:ml-[-48em] lg:ml-[-48em] lg:w-[370px] bigmd:ml-[-54em] bigmd:w-[420px] biglg:w-[480px] biglg:ml-[-63em] xl:w-[591px] 2xl:w-[621px] 2xl:ml-[-78em] 3xl:ml-[-93em] 4xl:ml-[-102em]  xl:ml-[-72em] ">
          <textarea
            value={formData.additionalInformation}
            className={`border  border-[#A4A4A4] md:h-[14vh] bigmd:h-[10vh] lg:h-[23vh] biglg:h-[17.5vh] xl:h-[17vh] 2xl:h-[18vh] w-full rounded-md resize-y overflow-y-auto word-wrap break-word`}
            name="additionalInformation"
            placeholder="Additional Information"
            onChange={(e: any) => handleInputChange(e)}
          />
        </div>

        <div className="flex gap-[22px]  mt-[8em] ml-[-2em] 360:mt-[1em]  375:mt-[1em]  md:mt-[5em] md:ml-[-23.7em] bigmd:ml-[-26.5em] lg:mt-[3em] lg:ml-[-25em] biglg:ml-[-31.5em] xl:ml-[-42em] 2xl:ml-[-43.5em] 2xl:mt-[5em] 3xl:mt-[10em]">
          <label
            htmlFor="reoccurring"
            className=" inline-flex  font-sm md:mt-[8em] bigmd:mt-[8em] lg:mt-[9em] biglg:mt-[9em] xl:ml-[3em] xl:mt-[9em] 2xl:mt-[8.2em] 3xl:mt-[5.5em]"
          >
            Reoccurring Invoice
          </label>
          <div className="xl:mt-[9em] mt-[0.2em] lg:mt-[9em] md:mt-[8em] 2xl:mt-[8em]">
            <CheckboxComponent
              checked={Boolean(formData?.isReoccurring)}
              label={''}
              onChange={(e) => {
                setIsReoccurringChecked(e.target.checked);
                handleIsReoccurringChange(e);
              }}
              name="isReoccurring"
            />
          </div>
          <div
            className="relative xl:mt-[9.5em] ml-[-1em] 2xl:mt-[8em] 3xl:mt-[6em] biglg:mt-[9.4em] lg:mt-[9em] md:mt-[8em] hidden lg:block"
            onMouseEnter={handleInfoCircleHover}
            onMouseLeave={handleInfoCircleMouseLeave}
          >
            {isMiniCardCustomerVisible ? (
              <div className="absolute z-10">
                <MiniCard
                  text1="Set up a recurring invoice to automatically bill"
                  text2="your client on a scheduled basis, saving you time"
                  text3="and ensuring consistent payments."
                  icon={<InfoCircle />}
                />
              </div>
            ) : (
              <InfoCircle />
            )}
          </div>
        </div>

        {isReoccurringChecked && (
          <div className="flex flex-row  justify-between items-start gap-8 mt-[2em] ml-[-4em]  md:mt-[16em] md:ml-[-14em] xl:mr-[26em] lg:ml-[-19em] xl:mt-[18em]">
            <div className=" w-[157px] text-left ml-[2em]">
              <label htmlFor="isReoccurringGroupName" className="block font-sm text-[12px] ml-[0.3em]">
                To be Repeated Every
              </label>

              <DropdownComponent
                name="reoccurringGroupName"
                options={REOCCURRING_FREQUENCY}
                error="To be Repeated Every"
                placeholder="Repeated Every"
                selectedValue={formData.reoccurringGroupName}
                value={formData.reoccurringGroupName}
                onChange={handleDropDownChange}
                iconClassName="mt-[2px] mr-[10px]"
                dropdownClassName=" w-[157px] xl:w-[] xl:mr-[26em] bg-white rounded border-1 border-[#A4A4A4] lg:mt-[0.3em] md:mt-[0.3em] 375:mt-[] 360:mt-[0.3em] "
              />
              {validationResults.reoccurringGroupName && (
                <span className="text-red-500">{validationResults.reoccurringGroupName} </span>
              )}
              {draftValidationResults.reoccurringGroupName && (
                <span className="text-red-500">{draftValidationResults.reoccurringGroupName}</span>
              )}
            </div>
            <div className="w-[157px] ml-3em xl:mr-[1em]">
              <label htmlFor="isReoccurringEndDate" className="block font-sm text-[12px] ml-[0.3em]">
                End Date
              </label>
              <InputComponent
                type="date"
                className=" rounded placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4] w-[157px] mt- py-4 360:w-[150px] xl:w-[] xl:mr-[1em]"
                placeholder="End Date"
                value={formData.isReoccurringEndDate}
                name="isReoccurringEndDate"
                handleChange={handleInputChange}
                restrictPreviousDates={true}
                error={validationResults.isReoccurringEndDate || draftValidationResults.isReoccurringEndDate}
              />
            </div>
          </div>
        )}
      </div>
      <hr className="xl:mt-[5em]" />
      <div className="lg:ml-[0.4em] ml-[-0.6em] md:ml-[-1.3em] bigmd:ml-[-0.1em] xl:ml-[0.2em] md:mt-[-0.5em] xl:mt-[-5em] biglg:ml-[-0.5em] 540:ml-[4em] 3xl:ml-[-3em] ">
        <div className="  flex xl:ml-[-0.5em] biglg:ml-[-0.5em] mt-[1em] ml-[-1em] lg:text-[20px]  text-[#044E97] ">
          <p>Send Invoice To Customer</p>
        </div>
        <div className="bg-[#D9D9D9] w-[300px] px-[15px] py-3 text-black font-normal flex items-center justify-between ml-[-1em]">
          <div className="">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="radio"
                value="sendEmail"
                onChange={handleSendEmailChange}
                name="sendEmail"
                checked={sendEmail}
              />
                 <span className="ml-3 py-2 inline-block text-gray-900 lg:text-[20px] xl:text-[20px] md:text-[20px] text-[16px] xl:ml-3 lg:ml-3 md:ml-3 biglg:ml-3 bigmd:ml-3 ">  Share Via Mail</span>
            </label>
          </div>
        </div>
        <div className="bg-[#D9D9D9] mt-[-2em] w-[300px] px-[15px] py-3 text-black font-normal flex items-center justify-between ml-[-1em]">
          <div className="">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="radio"
                value="shouldSendWhatsApp"
                onChange={handleshouldSendWhatsAppChange}
                name="shouldSendWhatsApp"
                checked={shouldSendWhatsApp}
              />
                 <span className="ml-3 py-2 inline-block text-gray-900 lg:text-[20px] xl:text-[20px] md:text-[20px] text-[16px] xl:ml-3 lg:ml-3 md:ml-3 biglg:ml-3 bigmd:ml-3 ">  Share Via Whatsapp</span>
            </label>
          </div>
        </div>
        <hr className='border-t-1 w-[100px] px-2 '/>
        <div className="bg-[#D9D9D9] w-[300px] px-[15px] py-3 text-black font-normal flex items-center justify-between ml-[-1em]">
          <label htmlFor="markAsPaid" className="lg:font-sm">
            Mark invoice as paid
          </label>
          <div className="mt-[-0.3em]">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                value="markAsPaid"
                className="sr-only peer"
                onChange={handleMarkAsPaidChange}
                name="markAsPaid"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummary;
